import 'semantic-ui-less/semantic.less';
import reportWebVitals from './reportWebVitals';
import { createRoot, Root } from 'react-dom/client';

export interface IHost {
  module: string;
  host: string;
}

declare global {
  interface Window {
    bearerToken?: string;
    bearerTokenExpiresOn?: Date | null;
    bearerTokenExtExpiresOn?: Date | null;
    userHash?: string;
  }
}

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

const containerId = 'root';
let root: Root | undefined;

import('./Root')
  .then((module) => {
    const RootApp = module.Root;
    const container = document.getElementById(containerId);
    if (!container) {
      throw new Error(`Container element with id "${containerId}" was not found!`);
    }
    root = createRoot(container);
    root.render(<RootApp />);
  })
  .catch((error) => console.log('error', error));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
